import banddraftLogo from "../../assets/banddraft-logo.png";
import globals from "../../styles/globals.module.css";

function Logo(props: { className?: string; style?: React.CSSProperties }) {
  const { className, style } = props;
  return (
    <img
      className={`${globals["logo"]}${className ? ` ${className}` : ""}`}
      src={banddraftLogo}
      style={style}
      alt="logo"
    />
  );
}

export default Logo;
